/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { Box } from '@atlaskit/primitives';
import { ReactionView } from './ReactionView';
export var ReactionsList = function ReactionsList(_ref) {
  var reactions = _ref.reactions,
    selectedEmojiId = _ref.selectedEmojiId,
    emojiProvider = _ref.emojiProvider,
    ProfileCardWrapper = _ref.ProfileCardWrapper;
  return jsx(Box, null, reactions.map(function (reaction) {
    if (reaction.emojiId === selectedEmojiId) {
      return jsx(ReactionView, {
        key: reaction.emojiId,
        reaction: reaction,
        selectedEmojiId: selectedEmojiId,
        emojiProvider: emojiProvider,
        ProfileCardWrapper: ProfileCardWrapper
      });
    } else {
      return null;
    }
  }));
};